module.exports = __webpack_public_path__ + "d6ac005132244d427b7af58dd3db44a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/lawbreakers/redfalls.png
// module id = 1074
// module chunks = 0